import { ref } from "vue";

// 전역 채팅 상태
const isChatOpen = ref(false);
const unreadMessageCount = ref(0);

// 전역 알림 상태
const isNotificationOpen = ref(false);

// 읽지 않은 알림 개수 (isNew가 true인 것만 카운트)
const unreadNotificationCount = ref(0);

export const useChat = () => {
  const toggleChat = () => {
    if (isChatOpen.value) {
      // 이미 열려있으면 닫기
      isChatOpen.value = false;
    } else {
      // 닫혀있으면 열기 (알림이 열려있으면 먼저 닫기)
      if (isNotificationOpen.value) {
        isNotificationOpen.value = false;
      }
      isChatOpen.value = true;
    }
  };

  const openChat = () => {
    // 알림이 열려있으면 먼저 닫기
    if (isNotificationOpen.value) {
      isNotificationOpen.value = false;
    }
    isChatOpen.value = true;
  };

  const closeChat = () => {
    isChatOpen.value = false;
  };

  const toggleNotification = () => {
    if (isNotificationOpen.value) {
      // 이미 열려있으면 닫기
      isNotificationOpen.value = false;
    } else {
      // 닫혀있으면 열기 (채팅이 열려있으면 먼저 닫기)
      if (isChatOpen.value) {
        isChatOpen.value = false;
      }
      isNotificationOpen.value = true;
    }
  };

  const openNotification = () => {
    // 채팅이 열려있으면 먼저 닫기
    if (isChatOpen.value) {
      isChatOpen.value = false;
    }
    isNotificationOpen.value = true;
  };

  const closeNotification = () => {
    isNotificationOpen.value = false;
  };

  return {
    isChatOpen,
    unreadMessageCount,
    toggleChat,
    openChat,
    closeChat,
    isNotificationOpen,
    toggleNotification,
    openNotification,
    closeNotification,
    unreadNotificationCount,
  };
};

